module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Target-9fcffc4d515f9090fddda3d6b1c9e58d.svg";